/**
 * Settles once the animations and transitions running on `element` and its
 * descendants have finished — a collapsible growing open, say — so what is
 * measured afterwards is the final layout; at once when nothing runs (or the
 * browser can't tell, as in jsdom). Paused animations and ones that repeat
 * forever (a loading pulse) are not waited for; cancelled ones count as done.
 */
export function whenAnimationsSettle(element: Element): Promise<void> {
  const running = element.getAnimations?.({ subtree: true }) ?? [];
  return Promise.all(
    running
      .filter(
        animation =>
          animation.playState === 'running' &&
          Number.isFinite(animation.effect?.getComputedTiming().endTime)
      )
      .map(animation => animation.finished.catch(() => undefined))
  ).then(() => undefined);
}
